import { makeStyles } from '@mui/styles';

/* eslint-disable no-magic-numbers */
export const useStyles = makeStyles((theme) => ({
  modal: {
    minWidth: theme.spacing(75),
  },
  modalTitle: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5, 3),
    fontSize: theme.typography.h3.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    '& .MuiIconButton-root': {
      top: theme.spacing(2),
      right: theme.spacing(3),
      color: theme.palette.emphasis.high,
    },
  },
  modalContent: {
    padding: theme.spacing(2.375, 0),
    margin: theme.spacing(2, 3, 1),
    overflowY: 'hidden',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  modalActions: {
    padding: theme.spacing(1, 3, 2),
  },
  closeButton: {
    padding: theme.spacing(1.25),
    '& .MuiSvgIcon-root': {
      fontSize: theme.spacing(3),
    },
  },
  secondaryButton: {
    fontWeight: theme.typography.fontWeightMedium,
    minWidth: theme.spacing(4.75),
    marginLeft: `${theme.spacing(0.75)}px !important`,
  },
  helperTextStyle: {
    padding: theme.spacing(0, 3),
    marginBottom: theme.spacing(0),
    ...theme.typography.body1,
  },
}));
